import {AxiosInstance} from "axios";
import {FeatureRequestCommentEntity} from "@fenix/bug-report-entities/bug-report-entities";
import FeatureCommentRepositoryInterface from "@/services/Bug-report/Feature-request/Comments/interfaces";

export default class FeatureCommentRepository implements FeatureCommentRepositoryInterface {
  constructor(private readonly axios: AxiosInstance) {
  }

  public async createComment(featureRequestId: number, body: string): Promise<FeatureRequestCommentEntity> {
    const url = `bug-report/features/${featureRequestId}/comment`;
    const res = await this.axios.post(url, {body});
    return res.data;
  }

  public async getAll(featureRequestId:number, page?: number, take?: number, desc?: boolean): Promise<FeatureRequestCommentEntity[]> {
    const url = `bug-report/features/${featureRequestId}/comment?page=${page}&take=${take}&desc=${desc}`;
    const res = await this.axios.get(url);
    return res.data;
  }
}
